import styled from 'styled-components';

export const Label = styled.span`
  color: ${({ theme }) => theme.colorTokens.hierarchy.h1};
`;
